/**
 * The query-key roots that can hold decrypted finance.
 *
 * Read in two places: the cache persister leaves them out, so nothing
 * decrypted is ever written to local storage, and locking removes them, so
 * nothing decrypted outlives the key in memory. A finance query under any
 * other root would be both persisted and kept after locking - add the root
 * here in the same change.
 */
export const FINANCE_QUERY_ROOTS = [
  'invoices',
  'invoice',
  'invoice-summary',
  'invoice-settings',
  'invoice-clients',
  'invoice-taxes',
  'gst-months',
  'invoice-gst',
  'gst-receipts',
  'finance-keys',
  'finance-access',
] as const
